import React from 'react';
import {
  Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table, makeStyles
} from '@material-ui/core';
import moment from 'moment';
import CountUp from 'react-countup';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: 'red'
  },
  colorRecord: {
    backgroundColor: 'green'
  },
  bold: {
    fontWeight: 600
  }
}));

export default class ComponentToPrint extends React.Component {
  render() {
    const totalAmount = this.props.totalAmount;
    const searchData = this.props.searchData;
    const groupedData = this.props.groupedData;
    const classes = this.props.UseStyles;

    return (
      <div>
        <div
          style={{
            width: '1093px',
            height: '1059px',
            padding: '20px',
            marginBottom: '14rem'
          }}
        >
          <br />
          <h2>
            <center>
              <u>Ledger Transaction Details Report</u>
            </center>
          </h2>
          <h3>
            <center>
              {searchData.groupName} - {' '}
              {searchData.factoryName} <br></br>
              Start Date: {searchData.startDate}<br></br>
              End Date: {searchData.endDate}<br></br>
              Status: {searchData.status == 3 ? "Rejected" : searchData.status == 2 ? "Approved" : searchData.status == 1 ? "Pending" : searchData.status == 0 ? "All" : ""}<br></br>
              Voucher Type: {searchData.voucherTypeID == 3 ? "Journel" : searchData.voucherTypeID == 2 ? "Receiving" : searchData.voucherTypeID == 1 ? "Payment" : searchData.voucherTypeID == 0 ? "All" : ""}<br></br>
            </center>
          </h3>
          <div>&nbsp;</div>
          <div>
            <Box minWidth={1050}>
              <TableContainer>
                <Table aria-label="caption table">
                  <TableHead style={{}}>
                    <TableCell align={'center'}>Voucher Code</TableCell>
                    <TableCell align={'center'}>Date</TableCell>
                    <TableCell align={'center'}>Status</TableCell>
                    <TableCell align={'center'}>Ledger Account Code</TableCell>
                    <TableCell align={'center'}>Ledger Account Name</TableCell>
                    <TableCell align={'center'}>Description</TableCell>
                    <TableCell align={'right'}>Debit</TableCell>
                    <TableCell align={'right'}>Credit</TableCell>
                  </TableHead>
                  <TableBody>
                    {groupedData != null || groupedData.length != 0
                      ? groupedData.map(item => (
                        <>
                          {item.reportList.map((data1, index) => (
                            <TableRow>
                              {index == 0 ? (
                                <>
                                  <TableCell
                                    align={'center'}
                                    rowSpan={item.reportList.length}
                                  >
                                    {item.refVouchCode}
                                  </TableCell>
                                  <TableCell
                                    align={'center'}
                                    rowSpan={item.reportList.length}
                                  >
                                    {
                                      moment(item.createdDate.toString())
                                        .format()
                                        .split('T')[0]
                                    }
                                  </TableCell>

                                  <TableCell align="center" rowSpan={item.reportList.length}>

                                    {data1.status === 3 ? "Rejected" : data1.status === 2 ? "Approved" : data1.status === 1 ? "Pending" : ""}
                                  </TableCell>
                                </>
                              ) : null}

                              <TableCell align={'center'}>
                                {data1.ledgerAccountCode}
                              </TableCell>
                              <TableCell align={'center'}>
                                {data1.ledgerAccountName}
                              </TableCell>
                              <TableCell align={'center'}>
                                {data1.description}
                              </TableCell>
                              <TableCell align={'right'}>
                                <CountUp
                                  end={data1.debit}
                                  separator=","
                                  decimals={2}
                                  decimal="."
                                  duration={0.1}
                                />
                              </TableCell>
                              <TableCell align={'right'}>
                                <CountUp
                                  end={data1.credit}
                                  separator=","
                                  decimals={2}
                                  decimal="."
                                  duration={0.1}
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                          <TableRow style={{}}>
                            <TableCell align={'center'}></TableCell>
                            <TableCell align={'center'}></TableCell>
                            <TableCell align={'center'}></TableCell>
                            <TableCell
                              align={'right'}
                              style={{ fontWeight: 'bold' }}
                            >
                              Total
                            </TableCell>
                            <TableCell align={'center'}></TableCell>
                            <TableCell align={'center'}></TableCell>
                            <TableCell
                              align={'right'}
                              style={{ fontWeight: 'bold' }}
                            >
                              <CountUp
                                end={Number(
                                  item.reportList.debit == undefined
                                    ? '0'
                                    : item.reportList.debit
                                )}
                                separator=","
                                decimals={2}
                                decimal="."
                                duration={0.1}
                              />
                            </TableCell>
                            <TableCell
                              align={'right'}
                              style={{ fontWeight: 'bold' }}
                            >
                              <CountUp
                                end={Number(
                                  item.reportList.credit == undefined
                                    ? '0'
                                    : item.reportList.credit
                                )}
                                separator=","
                                decimals={2}
                                decimal="."
                                duration={0.1}
                              />
                            </TableCell>
                          </TableRow>
                        </>
                      ))
                      : null}
                  </TableBody>

                  <TableRow style={{}}>
                    <TableCell align={'center'}>
                      <b>Final Total</b>
                    </TableCell>
                    <TableCell align={'center'}></TableCell>
                    <TableCell align={'center'}></TableCell>
                    <TableCell align={'center'}></TableCell>
                    <TableCell align={'center'}></TableCell>
                    <TableCell align={'center'}></TableCell>
                    <TableCell align={'right'}>
                      <b>
                        <CountUp
                          end={totalAmount.debitTotal}
                          separator=","
                          decimals={2}
                          decimal="."
                          duration={0.1}
                        />
                      </b>
                    </TableCell>

                    <TableCell align={'right'}>
                      <b>
                        <CountUp
                          end={totalAmount.creditTotal}
                          separator=","
                          decimals={2}
                          decimal="."
                          duration={0.1}
                        />
                      </b>
                    </TableCell>
                  </TableRow>
                </Table>
              </TableContainer>
            </Box>
          </div>
        </div>
      </div>
    );
  }
}
